module.exports = __webpack_public_path__ + "img/filters-white.af5e660a.svg";